import { Component, Input, ViewEncapsulation } from '@angular/core';
import { getCallCostProviders, providerCallCostsSearch } from 'src/app/common-components/helpers/provider-helper';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { CallCostPrivileges } from '../models/call-cost-privileges';
import { CallCostProviders } from '../models/call-cost-providers.model';
import { CallCostOrderingOptions, CallCostRegisterOptions } from '../models/call-cost-register-options';
import { CallCostRegisterListItem } from '../models/call-cost-register-results.model';
import { selectQuickFilters } from '../state/call-cost-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-call-register-view',
    styleUrls: ['./call-cost-register-view.component.scss'],
    templateUrl: './call-cost-register-view.component.html',
    standalone: false
})
export class CallCostRegisterViewComponent extends EntityRegisterView<
   CallCostRegisterListItem,
   CallCostRegisterOptions,
   CallCostOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => CallCostRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() includeInactive: boolean;

   @Input() callCostPrivileges: CallCostPrivileges;

   providers = [getCallCostProviders(), ' '];

   selectedProvider: any;

   pluralName = 'Call Costs';

   providerDisplayWith(option: CallCostProviders): string {
      return `${option ?? ''}`;
   }

   providerSearch(searchText: string) {
      this.providers = providerCallCostsSearch(searchText);
   }

   providerReset() {
      this.providers = getCallCostProviders();
   }

   getRouterLink(id: number) {
      return '0';
   }

   onProviderTypeSelected(providerType: string) {
      this.registerOptions = { ...this.registerOptions, typeName: providerType };
      this.quickFilterChange.emit(this.registerOptions);
      this.selectedProvider = providerType;
   }
}
